import { useParams } from 'react-router-dom';
import type { PublicMapRouteParams } from '~/_shared/constants/routes';
import { ReportPageComponent } from '~/report/page/reportPage.component';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';

export const ReportPageContainer = () => {
  const { mapShareId = '' } = useParams<PublicMapRouteParams>();
  const mapId = useMapIdSelector();

  return (
    <ReportPageComponent mapId={mapId} mapShareId={mapShareId} />
  );
};
